import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAnglesLeft,
  faAnglesRight,
  faArrowRight,
  faArrowUpRightFromSquare,
  faArrowsRotate,
  faAward,
  faBan,
  faBars,
  faBellSlash,
  faBolt,
  faBoxArchive,
  faBuilding,
  faCalendarDays,
  faCamera,
  faCaretDown,
  faCaretRight,
  faCheck,
  faChess,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleInfo,
  faClock,
  faComment,
  faCopy,
  faCreditCard,
  faDice,
  faDove,
  faDownload,
  faDungeon,
  faEarthAmericas,
  faEdit,
  faEllipsis,
  faEllipsisV,
  faEnvelope,
  faEye,
  faFaceSmile,
  faFile,
  faFileCircleExclamation,
  faFileCode,
  faFileExport,
  faFileLines,
  faFilePdf,
  faFileZipper,
  faFilter,
  faFlag,
  faFolder,
  faGear,
  faGlobe,
  faGlobeAsia,
  faHandHoldingHeart,
  faHeart,
  faHome,
  faImage,
  faKey,
  faList,
  faListCheck,
  faLocationDot,
  faLock,
  faMapMarker,
  faMessage,
  faMicrophone,
  faMinus,
  faMusic,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPencil,
  faPhone,
  faPhotoFilm,
  faPlus,
  faPrint,
  faRedo,
  faReply,
  faReplyAll,
  faRotate,
  faRoute,
  faSearch,
  faShare,
  faShareAlt,
  faShareNodes,
  faShoppingBag,
  faShoppingCart,
  faSort,
  faSquareCheck,
  faStar,
  faTag,
  faTags,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTrashAlt,
  faTruck,
  faTruckFast,
  faTruckRampBox,
  faUndo,
  faUser,
  faUserPen,
  faUserCheck,
  faUserGear,
  faUserGroup,
  faUserPlus,
  faUsers,
  faVideo,
  faXmark,
  faClockRotateLeft,
  faLink,
  faTriangleExclamation,
  faSquare,
  faShuttleSpace,
  faPause,
  faUpload,
  faWandMagicSparkles,
  faCubes
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookSquare,
  faGulp,
  faTwitterSquare,
  faFacebook as fabFacebook,
  faTwitter as fabTwitter,
  faLinkedinIn as fabLinkedinIn,
  faFacebookMessenger as fabFacebookMessenger,
  faYoutube as fabYoutube,
  faArtstation as fabArtstation,
  faBehance as fabBehance,
  faChrome,
  faFirefoxBrowser,
  faGoogle as fabGoogle
} from '@fortawesome/free-brands-svg-icons';
import {
  faStar as farStar,
  faHeart as farHeart,
  faCreditCard as farCreditCard,
  faCalendarPlus as farCalendarPlus,
  faFaceSmile as farFaceSmile,
  faArrowAltCircleDown as farArrowAltCircleDown
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faShuttleSpace,
  faSearch,
  faClock,
  faEllipsis,
  faCaretRight,
  faChevronDown,
  faGulp,
  faPalette,
  faTimes,
  faArrowsRotate,
  faCopy,
  faMinus,
  faPlus,
  faTrash,
  faTrashAlt,
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faAnglesLeft,
  faAnglesRight,
  faArrowUpRightFromSquare,
  faCheck,
  faStar,
  farStar,
  faBars,
  faFacebookSquare,
  faTwitterSquare,
  faBolt,
  faHeart,
  farHeart,
  faShare,
  faShareAlt,
  faShoppingCart,
  faReply,
  faThumbsUp,
  faThumbsDown,
  faXmark,
  faAngleDown,
  faAngleUp,
  faKey,
  fabFacebook,
  fabTwitter,
  fabLinkedinIn,
  faCamera,
  faEdit,
  faShoppingCart,
  faHome,
  faUser,
  faFilter,
  faDownload,
  faPrint,
  faShoppingBag,
  faPhone,
  faTruck,
  faTruckFast,
  faTruckRampBox,
  faRotate,
  faFileExport,
  faUndo,
  faPen,
  faAward,
  faChess,
  faDove,
  faDungeon,
  faSort,
  faPaperclip,
  faPencil,
  faImage,
  faFileZipper,
  faFileLines,
  faList,
  faEarthAmericas,
  faCreditCard,
  faListCheck,
  faUserPlus,
  faCircle,
  faMessage,
  faVideo,
  faEnvelope,
  farCreditCard,
  faEllipsisV,
  faTag,
  faSquareCheck,
  faCalendarDays,
  faArrowRight,
  faBoxArchive,
  faLocationDot,
  faEye,
  faComment,
  faMapMarker,
  farCalendarPlus,
  faShareNodes,
  fabFacebookMessenger,
  faRoute,
  faFaceSmile,
  faMicrophone,
  farFaceSmile,
  faPaperPlane,
  faUserPen,
  faPaperPlane,
  faUserGroup,
  faUserCheck,
  faUsers,
  faPhotoFilm,
  faDice,
  faUserGear,
  faBellSlash,
  faGear,
  faHandHoldingHeart,
  faFlag,
  faBan,
  faPhotoFilm,
  faFolder,
  farArrowAltCircleDown,
  faFileCode,
  faFileCircleExclamation,
  faRedo,
  faMusic,
  faFilePdf,
  faReplyAll,
  faFile,
  faTags,
  faCircleInfo,
  faBuilding,
  faGlobe,
  faLock,
  fabYoutube,
  fabArtstation,
  fabBehance,
  faGlobeAsia,
  faCaretDown,
  faClockRotateLeft,
  faLink,
  faChrome,
  faFirefoxBrowser,
  fabGoogle,
  faTriangleExclamation,
  faSquare,
  faPause,
  faUpload,
  faWandMagicSparkles,
  faCubes
);
